import React, { Fragment } from 'react'

import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { fetchAirlines } from 'actions/catalog/airlines'
import { fetchAirports } from 'actions/catalog/airports'
import { getFlightSchedule } from 'actions/flightSchedule'
import { getFlightStatus } from 'actions/flightStatus'
import { setFlightStatusSearch } from 'actions/flightStatusSearch'
import FlightsSearchBoxCollapsible from 'components/flights-search-box-collapsible'
import { RadioGroup } from 'components/radio-button'
import e2eClasses from 'constants/e2eClasses'
import FLIGHT_STATUS from 'constants/flightStatus'
import { SEARCH_BOX_TABS } from 'constants/searchBox'
import { isFlightStatusRoute } from 'helpers/routeMatchers'
import { buildURLEncoded, getUrlParams, objectToUrlParams } from 'helpers/url'
import { generateHomeRoute } from 'helpers/url/localization'
import { isEmpty, isMobile } from 'helpers/utils'
import { mapMediaType } from 'selectors/mediaType'

import FlightNumber from './flightNumber'
import FlightRoute from './flightRoute'
import { FlightContainer, Content, RadioGroupContainer, Title } from './styled'

const Radios = props => (
  <RadioGroupContainer mobileSearchBox={props.mobileSearchBox} hidden={props.hidden}>
    <RadioGroup
      name="searchType"
      options={props.getFlightSearchRadioGroupOptions()}
      onChange={props.handleFlightSearchChange}
      horizontal
    />
  </RadioGroupContainer>
)

const Form = props => {
  const searchForm =
    props.searchType === FLIGHT_STATUS.ROUTE ? (
      <FlightRoute flightStatusPage={props.isFlightStatusPage()} />
    ) : (
      <FlightNumber flightStatusPage={props.isFlightStatusPage()} />
    )

  return <FlightContainer hidden={props.hidden}>{searchForm}</FlightContainer>
}

class FlightStatusSearchBox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      searchType: null,
      showSearchBox: false
    }

    if (this.isFlightStatusPage()) {
      const { origin, destination, departureDate, flightNumber } = this.getParamsFromURL()

      if (!departureDate && !origin && !destination && !flightNumber) {
        const url = buildURLEncoded(generateHomeRoute(this.props.i18n.language), {
          activeTab: SEARCH_BOX_TABS.FLIGHT_STATUS
        })

        return this.props.history.push(url)
      }
    }
  }

  isFlightStatusPage = () => isFlightStatusRoute(this.props.location)

  getParamsFromURL = () => getUrlParams(this.props.location.search.split('?').pop())

  componentDidMount = () => {
    const { airports, airlines } = this.props

    isEmpty(airports) && this.props.fetchAirports()
    isEmpty(airlines) && this.props.fetchAirlines()

    const { origin, destination, departureDate, flightNumber } = this.getParamsFromURL()

    const searchType = origin && destination ? FLIGHT_STATUS.ROUTE : FLIGHT_STATUS.FLIGHT_NUMBER
    this.props.setFlightStatusSearch(searchType)

    if (this.isFlightStatusPage() && departureDate) {
      if (origin && destination) {
        this.props.getFlightSchedule(departureDate, origin, destination, 'DAY')
      } else if (flightNumber) {
        this.props.getFlightStatus(objectToUrlParams({ departureDate, flightNumber }))
      }
    }

    this.setState({
      searchType
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.toggleSearchBox()
    }
  }

  handleFlightSearchChange = value => {
    this.setState({
      searchType: value
    })
  }

  getFlightSearchRadioGroupOptions = () => {
    const keys = [
      {
        value: FLIGHT_STATUS.FLIGHT_NUMBER,
        text: this.props.t('general.flight-status.search.flight-number'),
        e2eClass: e2eClasses.searchBox.statusOptionNumber
      },
      {
        value: FLIGHT_STATUS.ROUTE,
        text: this.props.t('general.flight-status.search.route'),
        e2eClass: e2eClasses.searchBox.statusOptionRoute
      }
    ]

    const { searchType } = this.state

    return keys.map(item => ({
      value: item.value,
      text: item.text,
      e2eClass: item.e2eClass,
      selected: searchType ? searchType === item.value : false
    }))
  }

  mobileSearchBox = () => {
    const { origin, destination, flightNumber, departureDate } = this.getParamsFromURL()

    return (
      <FlightsSearchBoxCollapsible
        isDefaultExpanded={!this.state.showSearchBox}
        origin={origin}
        destination={destination}
        departureDate={departureDate}
        flightNumber={flightNumber}
        onExpand={this.toggleSearchBox}
        fontSize={18}
      >
        <Radios
          mobileSearchBox
          getFlightSearchRadioGroupOptions={this.getFlightSearchRadioGroupOptions}
          handleFlightSearchChange={this.handleFlightSearchChange}
        />
        <Form searchType={this.state.searchType} isFlightStatusPage={this.isFlightStatusPage} />
      </FlightsSearchBoxCollapsible>
    )
  }

  toggleSearchBox = () => {
    this.setState({ showSearchBox: !this.state.showSearchBox })
  }

  render() {
    if (isMobile(this.props.mediaType)) {
      return (
        <Fragment>
          {this.isFlightStatusPage() && this.mobileSearchBox()}
          {!this.isFlightStatusPage() && (
            <Fragment>
              <Title>{this.props.t('general.flight-status.search.look-for-flight-status')}</Title>
              <Radios
                getFlightSearchRadioGroupOptions={this.getFlightSearchRadioGroupOptions}
                handleFlightSearchChange={this.handleFlightSearchChange}
              />
              <Form
                searchType={this.state.searchType}
                isFlightStatusPage={this.isFlightStatusPage}
              />
            </Fragment>
          )}
        </Fragment>
      )
    }

    return (
      <Content flightStatusPage={this.isFlightStatusPage()} C>
        <Radios
          getFlightSearchRadioGroupOptions={this.getFlightSearchRadioGroupOptions}
          handleFlightSearchChange={this.handleFlightSearchChange}
        />
        <Form searchType={this.state.searchType} isFlightStatusPage={this.isFlightStatusPage} />
      </Content>
    )
  }
}

const mapStateToProps = state => ({
  mediaType: mapMediaType(state)
})

const mapDispatchToProps = {
  setFlightStatusSearch,
  fetchAirports,
  fetchAirlines,
  getFlightSchedule,
  getFlightStatus
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(FlightStatusSearchBox))
)
